import { TextField } from "@mui/material";
import { GetTextFieldStyle } from "lib/styles/textField";

type props = {
	fullName?: string;
	setFullName: (name: string) => void;
};

export function NameField({ fullName, setFullName }: props) {
	const denseFieldSx = {
		"height": 40,
		"& .MuiInputBase-input": { py: 1 },
	} as const;

	return (
		<TextField
			label="Name"
			value={fullName || ""}
			onChange={(e) => setFullName(e.target.value)}
			size="small"
			sx={{ ...GetTextFieldStyle(), mt: 2 }}
			InputProps={{
				sx: {
					...denseFieldSx,
					backgroundColor: "action.disabledBackground",
				},
				readOnly: true,
			}}
			InputLabelProps={{ shrink: true }}
			disabled
		/>
	);
}
